'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _activeElement = require('./active-element');

var _activeElement2 = _interopRequireDefault(_activeElement);

var _disabled = require('./disabled');

var _disabled2 = _interopRequireDefault(_disabled);

var _focusRelevant = require('./focus-relevant');

var _focusRelevant2 = _interopRequireDefault(_focusRelevant);

var _focusable = require('./focusable');

var _focusable2 = _interopRequireDefault(_focusable);

var _onlyTabbable = require('./only-tabbable');

var _onlyTabbable2 = _interopRequireDefault(_onlyTabbable);

var _shadowed = require('./shadowed');

var _shadowed2 = _interopRequireDefault(_shadowed);

var _tabbable = require('./tabbable');

var _tabbable2 = _interopRequireDefault(_tabbable);

var _validArea = require('./valid-area');

var _validArea2 = _interopRequireDefault(_validArea);

var _validTabindex = require('./valid-tabindex');

var _validTabindex2 = _interopRequireDefault(_validTabindex);

var _visible = require('./visible');

var _visible2 = _interopRequireDefault(_visible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// exporting modules to be included the UMD bundle

exports.default = {
  activeElement: _activeElement2.default,
  disabled: _disabled2.default,
  focusRelevant: _focusRelevant2.default,
  focusable: _focusable2.default,
  onlyTabbable: _onlyTabbable2.default,
  shadowed: _shadowed2.default,
  tabbable: _tabbable2.default,
  validArea: _validArea2.default,
  validTabindex: _validTabindex2.default,
  visible: _visible2.default
};
module.exports = exports['default'];
//# sourceMappingURL=_is.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ally.js/is/_is.js
// module id = 123
// module chunks = 0